import 'reflect-metadata';
import { Container } from 'inversify';
import { TYPES } from './types';

// DataSources
import { DatabaseDataSource } from '../data/datasources/database/DatabaseDataSource';
import { MongoDataSourceImpl } from '../data/datasources/database/MongoDataSourceImpl';

// Repositories (only import what we're using)
import { ProductRepository, ProductCategoryRepository, UserRepository, CartRepository, BranchInventoryRepository } from '../domain/repositories';
import { ProductRepositoryImpl, ProductCategoryRepositoryImpl } from '../data/repositories/ProductRepositoryImpl';
import { UserRepositoryImpl } from '../data/repositories/UserRepositoryImpl';
import { CartRepositoryImpl } from '../data/repositories/CartRepositoryImpl';
import { BranchInventoryRepositoryImpl } from '../data/repositories/BranchInventoryRepositoryImpl';

// Use Cases (only import what we're implementing)
import { LoginUseCase } from '../domain/usecases/AuthenticationUseCases';
import { SearchProductsUseCase, GetAllProductsUseCase, GetProductsByCategoryUseCase, GetProductsAvailableInBranchUseCase, GetProductCategoriesUseCase } from '../domain/usecases/ProductUseCases';
import { AddItemToCartUseCase, CreateCartUseCase, CancelCartUseCase, UpdateCartItemQuantityUseCase } from '../domain/usecases/SaleUseCases';

// Use Case Implementations
import { LoginUseCaseImpl } from '../presentation/usecases/authentication/LoginUseCaseImpl';
import { SearchProductsUseCaseImpl } from '../presentation/usecases/products/SearchProductsUseCaseImpl';
import { GetAllProductsUseCaseImpl } from '../presentation/usecases/products/GetAllProductsUseCaseImpl';
import { GetProductsByCategoryUseCaseImpl } from '../presentation/usecases/products/GetProductsByCategoryUseCaseImpl';
import { GetProductCategoriesUseCaseImpl } from '../presentation/usecases/products/GetProductCategoriesUseCaseImpl';
import { AddItemToCartUseCaseImpl } from '../presentation/usecases/sales/AddItemToCartUseCaseImpl';
import { CreateCartUseCaseImpl } from '../presentation/usecases/sales/CreateCartUseCaseImpl';
import { CancelCartUseCaseImpl } from '../presentation/usecases/sales/CancelCartUseCaseImpl';
import { UpdateCartItemQuantityUseCaseImpl } from '../presentation/usecases/sales/UpdateCartItemQuantityUseCaseImpl';
import { GetProductsAvailableInBranchUseCaseImpl } from '../presentation/usecases/products/GetProductsAvailableInBranchUseCaseImpl';

/**
 * Dependency Injection Container
 * This configures all the bindings for clean architecture
 */
const container = new Container();

// ========== DATA SOURCES ==========
// Browser and Electron FO use REST; offline catalog/sales use OfflineSyncOrchestrator (SQLite).
container
  .bind<DatabaseDataSource>(TYPES.DatabaseDataSource)
  .to(MongoDataSourceImpl)
  .inSingletonScope();

// ========== REPOSITORIES ==========
container.bind<ProductRepository>(TYPES.ProductRepository).to(ProductRepositoryImpl);
container.bind<ProductCategoryRepository>(TYPES.ProductCategoryRepository).to(ProductCategoryRepositoryImpl);
container.bind<UserRepository>(TYPES.UserRepository).to(UserRepositoryImpl);
container.bind<CartRepository>(TYPES.CartRepository).to(CartRepositoryImpl);
container.bind<BranchInventoryRepository>(TYPES.BranchInventoryRepository).to(BranchInventoryRepositoryImpl);

// TODO: Implement other repositories
// container.bind<SaleRepository>(TYPES.SaleRepository).to(SaleRepositoryImpl);
// container.bind<CartRepository>(TYPES.CartRepository).to(CartRepositoryImpl);

// ========== USE CASES ==========
container.bind<LoginUseCase>(TYPES.LoginUseCase).to(LoginUseCaseImpl);
container.bind<SearchProductsUseCase>(TYPES.SearchProductsUseCase).to(SearchProductsUseCaseImpl);
container.bind<GetAllProductsUseCase>(TYPES.GetAllProductsUseCase).to(GetAllProductsUseCaseImpl);
container.bind<GetProductsByCategoryUseCase>(TYPES.GetProductsByCategoryUseCase).to(GetProductsByCategoryUseCaseImpl);
container.bind<GetProductCategoriesUseCase>(TYPES.GetProductCategoriesUseCase).to(GetProductCategoriesUseCaseImpl);
container.bind<AddItemToCartUseCase>(TYPES.AddItemToCartUseCase).to(AddItemToCartUseCaseImpl);
container.bind<CreateCartUseCase>(TYPES.CreateCartUseCase).to(CreateCartUseCaseImpl);
container.bind<CancelCartUseCase>(TYPES.CancelCartUseCase).to(CancelCartUseCaseImpl);
container.bind<UpdateCartItemQuantityUseCase>(TYPES.UpdateCartItemQuantityUseCase).to(UpdateCartItemQuantityUseCaseImpl);
container.bind<GetProductsAvailableInBranchUseCase>(TYPES.GetProductsAvailableInBranchUseCase).to(GetProductsAvailableInBranchUseCaseImpl);

console.log('📦 Dependency Injection Container configured successfully');
console.log('🔧 Database Type: MongoDB');

export default container; 